import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppFacade } from './+state/app.facade';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './+state/app.effects';
import { StoreModule } from '@ngrx/store';
import * as fromApp from './+state/app.reducer';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([AppEffects]),
    StoreModule.forFeature(fromApp.APP_FEATURE_KEY, fromApp.appReducer),
  ],
  providers: [AppFacade],
})
export class CignaForBrokersSharedDataAccessModule {}
